import React from "react";
const FolderIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="var(--color-theme-600)"
      ref={svgRef}
      {...props}
    >
      <path
        d="M20 18H4V8h16m0-2h-8l-2-2H4c-1.11 0-2 .89-2 2v12a2 2 0 002 2h16a2 2 0 002-2V8a2 2 0 00-2-2z"
        fillRule="evenodd"
      />
    </svg>
  )
);
FolderIcon.displayName = "FolderIcon";
export default FolderIcon;
